import React from "react";
import PropTypes from "prop-types";
import { PageTitle } from "./PageTitle";
import { ContentContainer } from "./ContentContainer";

function ContentManagement(props) {
    const { title, body } = props;

    return (
        <div>
            <PageTitle title={title}/>
            <ContentContainer>
                <div className="row">
                    <div className="col-md-4 text-center mb-5">
                        <img className="mb-0" src={require("../../../Assets/Images/services.png")} alt="NOT FOUND" />
                        <a className="text-center mt-0" href="http://www.velsol.com/" target="_blank" rel="noopener noreferrer">www.velsol.com</a>
                    </div>
                    <div className="col-md-8" dangerouslySetInnerHTML={{ __html: body }}/>
                </div>
            </ContentContainer>
        </div>
    );
}

ContentManagement.propTypes = {
    title: PropTypes.string,
    body: PropTypes.string
};

export default ContentManagement;